export default __webpack_public_path__ + "static/media/BA16.a7af01a9.jpg";